<template>
  <vue-date-picker
    v-bind="context?.attrs"
    v-model="dateValue"
    model-type="iso"
    :config="{ monthChangeOnScroll: false }"
    :time-config
    :text-input="{ selectOnFocus: true, applyOnBlur: true }"
    :placeholder
    :formats="{ preview: previewFormats }"
    :aria-labels="{ input: context?.label || 'Date Picker input' }"
    :input-attrs="{
      id: context?.id,
      name: context?.node?.name,
      hideInputIcon: true,
    }"
  />
</template>

<script setup>
import { VueDatePicker } from "@vuepic/vue-datepicker";
import { computed, ref, watch } from "vue";
const props = defineProps({
  context: {
    type: Object,
    required: true,
  },
});

const disableTimePicker =
  props.context?.attrs["disable-time-picker"] !== undefined;

const previewFormats = disableTimePicker
  ? "MMMM dd, yyyy"
  : "MMMM dd, yyyy hh:mm a";

const placeholder =
  props.context?.attrs?.placeholder || "MM/DD/YYYY, HH:MM AM/PM";
const timeConfig = computed(() => ({
  is24: false,
  timePickerInline: true,
  enableTimePicker: disableTimePicker ? false : true,
}));
const dateValue = ref(props.context.value || "");
watch(dateValue, () => {
  if (dateValue.value == null) {
    props.context.node.input("");
  } else {
    props.context.node.input(dateValue.value);
  }
});
</script>
